import { getFlags } from 'services/api.service'
import { isMarketplaceTrackerActive } from 'utils/marketplaceTracker'
import { LIST_NFT } from './listNFT.tx'
import { LIST_NFT_TRACKER } from './listNFTTracker.tx'
import { CANCEL_NFT_SALE } from './cancelNFTSale.tx'
import { CANCEL_NFT_SALE_TRACKER } from './cancelNFTSaleTracker.tx'
import { CHANGE_LISTING_PRICE } from './changeListingPrice.tx'
import { CHANGE_LISTING_PRICE_TRACKER } from './changeListingPriceTracker.tx'

async function shouldUseMarketplaceTrackerTransactions() {
  try {
    const flags = await getFlags()
    return isMarketplaceTrackerActive(flags)
  } catch (error) {
    console.error('Failed to fetch marketplace flags:', error)
    return false
  }
}

export async function getListNFTTransaction() {
  return (await shouldUseMarketplaceTrackerTransactions())
    ? LIST_NFT_TRACKER
    : LIST_NFT
}

export async function getCancelNFTSaleTransaction() {
  return (await shouldUseMarketplaceTrackerTransactions())
    ? CANCEL_NFT_SALE_TRACKER
    : CANCEL_NFT_SALE
}

export async function getChangeListingPriceTransaction() {
  return (await shouldUseMarketplaceTrackerTransactions())
    ? CHANGE_LISTING_PRICE_TRACKER
    : CHANGE_LISTING_PRICE
}
